import * as React from "react";

function SvgBimeAnalytics(props, ref) {
  return (
    <svg
      id="BIMEAnalytics_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="700 325 400 47.6"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style />
      <path
        d="M1024.6 473h-57.3c-2.8 0-5-2.2-5-5V254.4c0-2.8 2.2-5 5-5h57.3c2.8 0 5 2.2 5 5v213.5c0 2.8-2.3 5.1-5 5.1z"
        fill="#1ece6d"
      />
      <path
        d="M936 472.9h-58.6c-2.4 0-4.4-2-4.4-4.4V306c0-2.4 2-4.4 4.4-4.4H936c2.4 0 4.4 2 4.4 4.4v162.6c0 2.4-2 4.3-4.4 4.3z"
        fill="#ff004e"
      />
      <path
        d="M847.6 472.9h-60c-2 0-3.7-1.6-3.7-3.7v-113c0-2 1.6-3.7 3.7-3.7h60c2 0 3.7 1.6 3.7 3.7v113c-.1 2.1-1.7 3.7-3.7 3.7z"
        fill="#00b4ff"
      />
    </svg>
  );
}

export default React.forwardRef(SvgBimeAnalytics);
